import { graphqlClient } from '@topconagriculture/graphql-client';

import { API_CLIENTS } from '../../../config/constants';
import { SubscriptionInfo } from '../../../store/subscription/subscription.types';
import * as FETCH_SUBSCRIPTIONS from './gql/subscriptions.gql';
import * as FETCH_CLOUD_LINKS from './gql/getCloudLinks.gql';

export const getSubscriptions = ({
  applicationId,
  skus,
}: {
  applicationId: string;
  skus: string[];
}): Promise<SubscriptionInfo[]> => {
  return graphqlClient
    .getClient(API_CLIENTS.graphqlClient)
    .query({
      query: FETCH_SUBSCRIPTIONS,
      fetchPolicy: 'network-only',
      variables: {
        applicationId,
        skus,
      },
    })
    .then((res) => res.data.subscriptions.edges);
};

export const getCloudLinks = () => {
  return graphqlClient
    .getClient(API_CLIENTS.graphqlClient)
    .query({
      query: FETCH_CLOUD_LINKS,
      fetchPolicy: 'network-only',
    })
    .then((res) =>
      res.data.devices.edges.map((clNode) => ({
        ...clNode.node,
      })),
    );
};
